import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import TableRow from '../../atoms/table/TableRow';
import Magnifier from '../../atoms/icons/Magnifier';
import { useTranslation } from 'react-i18next';
const StyledTableRow = styled(TableRow) `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f7;
    padding: 30px 0;

    &:hover {
        background-color: #f5f5f7;
    }
`;
const Message = styled.span `
    display: block;
    font-size: 18px;
    color: #5d5d5d;
    text-align: center;
`;
const StyledMagnifier = styled(Magnifier) `
    fill: #c7c7c7;
    width: 37px;
    height: 37px;
    margin-bottom: 10px;
`;
const NoDataTableRow = ({ message, }) => {
    const { t } = useTranslation();
    const fallback = t(`dossier.no_result_fallback`);
    return (_jsxs(StyledTableRow, { children: [_jsx(StyledMagnifier, {}), _jsx(Message, { children: message || fallback })] }));
};
export default NoDataTableRow;
